export const MONTHLY_THRESHOLD = 120;
export const ONE_TIME_THRESHOLD = 50;

export function getAnnualTotal(amount, frequency) {
  const multiplier = frequency === 'monthly' ? 12 : 1;
  return amount * multiplier;
}

export function getAdditionalForBenefit(amount, frequency) {
  const multiplier = frequency === 'monthly' ? 12 : 1;
  return (
    (getBenefitThreshold(frequency) - getAnnualTotal(amount, frequency)) /
    multiplier
  );
}

export function receivingBenefit(amount, frequency) {
  return getAnnualTotal(amount, frequency) >= getBenefitThreshold(frequency);
}

export function getAmountWithFees(amount, coverFees) {
  const numericAmount = parseInt(amount, 10);
  if (coverFees) {
    return (
      numericAmount + Math.round((numericAmount * 0.029 + 0.3) * 100) / 100
    );
  } else {
    return numericAmount;
  }
}

export function formatMoney(amount) {
  const number = Number(amount);
  if (Number.isInteger(number)) {
    return number.toFixed(0);
  } else if (Number.isNaN(number)) {
    return amount;
  } else {
    return number.toFixed(2);
  }
}

function getBenefitThreshold(frequency) {
  if (frequency == 'once' || frequency == 'annually') {
    return ONE_TIME_THRESHOLD;
  } else {
    return MONTHLY_THRESHOLD;
  }
}
